export default {
  login: {
    phone: 'ဖုန်းနံပါတ်',
    phoneNumber: 'ဖုန်းနံပါတ်',
    password: 'လျှို့ဝှက်နံပါတ်',
    accountNumber: 'အကောင့်နံပါတ်',
    newPassword: 'လျှို့ဝှက်နံပါတ်အသစ်',
    confirmPassword: 'လျှို့ဝှက်နံပါတ်အသစ်ကိုအတည်ပြုပါ',
    forgotPassword: 'လျှို့ဝှက်နံပါတ်မေ့နေပါသလား?',
    contactAdmin: 'စီမံခန့်ခွဲသူကိုဆက်သွယ်ပါ',
    loginButton: 'ဝင်ရောက်ရန်',
    register: 'အကောင့်ဖွင့်ရန်',
    confirm: 'အတည်ပြုပါ',
    changePassword: 'လျှို့ဝှက်နံပါတ်ပြောင်းရန်',
    noAccount: 'သို့မဟုတ် အကောင့်မရှိသေးဘူးလား'
  },
  register: {
    title: 'အကောင့်ဖွင့်ရန်',
    verifyOTP: 'OTP ကုဒ်ကိုအတည်ပြုပါ',
    registerSuccess: 'Register Success',
    registrationComplete: 'သင့်မှတ်ပုံတင်မှုအောင်မြင်ပါသည်',
    enterPhonePrompt: 'သင့်ဖုန်းနံပါတ်ကိုထည့်ပါ',
    next: 'နောက်သို့',
    back: 'နောက်သို့',
    otpSentTo: 'OTP ကုဒ်ကိုသင့်မိုဘိုင်းဖုန်းသို့ပို့ပါမည်',
    phoneNumber: 'နံပါတ်',
    enterOTP: 'သင့်မိုဘိုင်းဖုန်းမှ OTP ကုဒ်ကိုထည့်ပါ',
    confirmOTP: 'OTP အတည်ပြုပါ',
    resendOTP: 'OTP ကုဒ်ကိုပြန်ပို့ပါ',
    enterPasswordPrompt: 'သင့်လျှို့ဝှက်နံပါတ်ကိုထည့်ပါ',
    password: 'လျှို့ဝှက်နံပါတ်',
    confirmPassword: 'လျှို့ဝှက်နံပါတ်အတည်ပြုပါ',
    selectBankPrompt: 'သင့်ဘဏ်ကိုရွေးပါ',
    selectBank: 'ဘဏ်ရွေးပါ',
    accountNumber: 'အကောင့်နံပါတ်',
    firstName: 'နာမည်',
    lastName: 'မျိုးနွယ်အမည်',
    registerButton: 'အကောင့်ဖွင့်ရန်',
    thankYouMessage: 'မှတ်ပုံတင်ခြင်းအတွက် ကျေးဇူးတင်ပါသည်။ အောက်ပါအသုံးပြုသူအမည်နှင့် လျှို့ဝှက်နံပါတ်ဖြင့် လော့ဂ်အင်ဝင်နိုင်ပါသည်',
    username: 'အသုံးပြုသူအမည်',
    loginButton: 'ဝင်ရောက်ရန်',
    or: 'သို့မဟုတ်',
    alreadyHaveAccount: 'အကောင့်ရှိပြီးသားလား'
  },
  registerErrors: {
    errorTitle: 'Error!',
    otpTitle: 'OTP!',
    enterOTP: 'သင်ရရှိသော OTP ကုဒ်ကိုထည့်ပါ!',
    invalidOTP: 'မမှန်ကန်သော OTP ကုဒ်၊ ထပ်စစ်ဆေးပါ!',
    otpNotFound: 'OTP ကုဒ်စနစ်တွင်မတွေ့ရှိပါ၊ စီမံခန့်ခွဲသူကိုဆက်သွယ်ပါ',
    selectBank: 'ဘဏ်တစ်ခုရွေးချယ်ပါ!',
    enterAccountNumber: 'အကောင့်နံပါတ်ထည့်ပါ!',
    enterFirstName: 'နာမည်ထည့်ပါ!',
    enterLastName: 'မျိုးနွယ်အမည်ထည့်ပါ!',
    enterPhone: 'ဖုန်းနံပါတ်ထည့်ပါ!',
    phoneLength: 'ဖုန်းနံပါတ်သည် ဂဏန်း 10 လုံးဖြစ်ရမည်!',
    phoneExists: 'ဤဖုန်းနံပါတ်သည် မှတ်ပုံတင်ပြီးသားဖြစ်သည်။ ပြဿနာရှိပါက ဆက်သွယ်ပါ',
    accountExists: 'ဤအကောင့်နံပါတ်သည် မှတ်ပုံတင်ပြီးသားဖြစ်သည်။ ပြဿနာရှိပါက ဆက်သွယ်ပါ',
    passwordMinLength: 'လျှို့ဝှက်နံပါတ်သည် အနည်းဆုံး 6 လုံးဖြစ်ရမည်!',
    passwordMismatch: 'လျှို့ဝှက်နံပါတ်များမကိုက်ညီပါ!',
    invalidCredentials: 'ဖုန်းနံပါတ် / လျှို့ဝှက်နံပါတ် မမှန်ကန်ပါ!'
  },
  messages: {
    title: 'သတင်းစကား!',
    enterPhone: 'သင့်ဖုန်းနံပါတ်ကိုထည့်ပါ!',
    enterPassword: 'သင့်လျှို့ဝှက်နံပါတ်ကိုထည့်ပါ!',
    invalidCredentials: 'ဖုန်းနံပါတ် / လျှို့ဝှက်နံပါတ် မမှန်ကန်ပါ!',
    contactAdminError: 'စီမံခန့်ခွဲသူကိုဆက်သွယ်ပါ',
    checkPasswordData: 'သင့်လျှို့ဝှက်နံပါတ်အချက်အလက်ကိုမှန်ကန်စွာစစ်ဆေးပါ!',
    passwordChangedSuccess: 'လျှို့ဝှက်နံပါတ်ကိုအောင်မြင်စွာပြောင်းလဲပြီးပါပြီ',
    completeAllInfo: 'အချက်အလက်အားလုံးကိုဖြည့်ပါ!',
    enterPhoneAndAccount: 'ဖုန်းနံပါတ်နှင့်အကောင့်နံပါတ်ကိုထည့်ပါ',
    enterNewPassword: 'လျှို့ဝှက်နံပါတ်အသစ်ကိုထည့်ပါ'
  },
  languages: {
    th: 'ထိုင်း',
    en: 'အင်္ဂလိပ်',
    my: 'မြန်မာ',
    ch: 'တရုတ်'
  },
  main: {
    heroTitle: 'ပြိုင်ပွဲများနှင့် အထူးအခွင့်အရေးများကို<br>ကျယ်ကျယ်ပြန့်ပြန့် တင်ဆက်ပေးနေပါတယ်',
    heroSubtitle: 'ထိုင်းနိုင်ငံတွင် အစီအစဉ်အများဆုံးဖြင့် နေ့တိုင်း ဖျော်ဖြေရန် အသင့်ရှိပါသည်',
    heroCta: 'အကောင့်ဖွင့်ပါ',
    searchPlaceholder: 'ဂိမ်းများ သို့မဟုတ် ပံ့ပိုးသူများကို ရှာဖွေပါ...',
    playButton: 'ကစားရန်',
    titles: {
      favorite: 'အကြိုက်ဆုံးဂိမ်းများ',
      hot: 'လူကြိုက်များဂိမ်းများ',
      new: 'ဂိမ်းအသစ်များ',
      casinoAll: 'ကာစီနိုအားလုံး',
      casinoProvider: 'ကာစီနို - {name}',
      sport: 'အားကစား',
      fishAll: 'ငါးပစ်ဂိမ်းများအားလုံး',
      fishProvider: 'ငါးပစ်ဂိမ်း - {name}',
      slotAll: 'စလော့ဂိမ်းများအားလုံး',
      slotProviders: 'စလော့ပံ့ပိုးသူများ',
      slotProvider: 'စလော့ဂိမ်း - {name}',
      card: 'ကတ်ဂိမ်းများ'
    }
  },
  header: {
    register: 'အကောင့်ဖွင့်ရန်',
    registerNow: 'ယခုအကောင့်ဖွင့်ရန်',
    login: 'ဝင်ရောက်ရန်',
    deposit: 'ငွေသွင်း',
    withdraw: 'ငွေထုတ်',
    account: 'အကောင့်',
    nav: {
      slot: 'Slot',
      casino: 'ကာစီနို',
      sport: 'အားကစား',
      event: 'အထူးခံစားခွင့်',
      privilege: 'အထူးခံစားခွင့်',
      promotion: 'ပရိုမိုးရှင်း',
      cashback: 'ငွေပြန်အမ်း',
      continue: 'ဆက်တိုက်သွင်း',
      continuousDeposit: 'ဆက်တိုက်သွင်း',
      partner: 'လုပ်ဖော်ကိုင်ဖက်',
      rewards: 'ဆုလက်ဆောင်လဲ',
      redeemRewards: 'ဆုလက်ဆောင်လဲ'
    },
    auth: {
      register: 'အကောင့်ဖွင့်ရန်',
      login: 'ဝင်ရောက်ရန်',
      logout: 'ထွက်ရန်',
      logoutConfirm: 'ထွက်လိုပါသလား?'
    },
    loginModal: {
      title: 'ဝင်ရောက်ရန်',
      phonePlaceholder: 'ဖုန်းနံပါတ်',
      passwordPlaceholder: 'လျှို့ဝှက်နံပါတ်',
      forgotPassword: 'လျှို့ဝှက်နံပါတ်မေ့နေပါသလား',
      submit: 'ဝင်ရောက်ရန်',
      problem: 'ပြဿနာရှိပါသလား',
      contactSupport: 'ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ'
    },
    registerModal: {
      title: 'အကောင့်ဖွင့်ရန်',
      phonePlaceholder: 'ဖုန်းနံပါတ်',
      confirm: 'အတည်ပြုပါ',
      back: 'နောက်သို့'
    },
    otp: {
      message: 'OTP ကုဒ်ကိုသင့်မိုဘိုင်းဖုန်းသို့ပို့ပါမည်',
      phoneNumber: 'နံပါတ်',
      placeholder: 'သင့်မိုဘိုင်းဖုန်းမှ OTP ကုဒ်ကိုထည့်ပါ',
      confirm: 'OTP အတည်ပြုပါ',
      resend: 'OTP ကုဒ်ကိုပြန်ပို့ပါ'
    },
    password: {
      newPlaceholder: 'လျှို့ဝှက်နံပါတ်သတ်မှတ်ပါ (6 လုံးနှင့်အထက်)',
      confirmPlaceholder: 'လျှို့ဝှက်နံပါတ်ထပ်ထည့်ပါ',
      currentPlaceholder: 'လက်ရှိလျှို့ဝှက်နံပါတ်',
      new: 'လျှို့ဝှက်နံပါတ်အသစ်',
      confirmNew: 'လျှို့ဝှက်နံပါတ်အသစ်ထပ်ထည့်ပါ'
    },
    bank: {
      accountNumberPlaceholder: 'အကောင့်နံပါတ်ထည့်ပါ',
      firstnamePlaceholder: 'နာမည်ထည့်ပါ',
      lastnamePlaceholder: 'မျိုးနွယ်အမည်ထည့်ပါ',
      warning: 'အချက်အလက်အားလုံးကို မှန်ကန်စွာဖြည့်ပါ၊ မဟုတ်ရင် ငွေထုတ်လို့မရပါ'
    },
    registerSuccess: {
      title: 'မှတ်ပုံတင်ခြင်းအောင်မြင်ပါသည်',
      usernameLabel: 'Username: ',
      passwordLabel: 'Password: '
    },
    depositModal: {
      title: 'PromptPay မှတစ်ဆင့်ငွေသွင်း',
      modalTitle: 'ငွေသွင်းရန်',
      click: 'Click',
      copy: 'ကူးယူရန်',
      scbBank: 'Siam Commercial Bank',
      ttbBank: 'TMBThanachart Bank',
      kbank: 'Kasikorn Bank',
      gsbBank: 'Government Savings Bank',
      truemoney: 'TrueMoney Wallet',
      promptPay: 'PromptPay ငွေသွင်း',
      warning: 'မှတ်ပုံတင်ထားသော အကောင့်နံပါတ်ကိုသာ အသုံးပြုပါ',
      promotionNotice: 'ပရိုမိုးရှင်းလိုချင်ရင် ငွေမလွှဲမီ ပရိုမိုးရှင်းခံယူရန် နှိပ်ပါ',
      generatingInfo: 'QR ကုဒ်ကို ရရှိရန် စောင့်ဆိုင်းပါ... ဤဝင်းဒိုးကို မပိတ်ပါနှင့်။',
      generatingWarning: 'ဤ QR ကုဒ်ကို တစ်ကြိမ်သာ သုံးစွဲနိုင်ပါသည်။ ထပ်မံစကန်မိမည်မဟုတ်ပါစေ။',
      receive: 'ခံယူရန်',
      notReceive: 'မခံယူပါ',
      noBonusNotice: 'ဘောနပ်စ်မပါဘဲ ငွေသွင်း - ချက်ချင်းထုတ်ယူနိုင် အခြေအနေမရှိ',
      amountPlaceholder: 'ငွေသွင်းလိုသည့် ပမာဏကိုထည့်ပါ',
      slipReminder: 'ငွေ ၅ မိနစ်အတွင်း မရောက်ပါက ဤနေရာတွင် ဆလစ်ဖိုင်ကို အပ်ဆင်ပါ!',
      closeButton: 'ဝင်းဒိုးပိတ်ရန်',
      confirm: 'ငွေသွင်းအတည်ပြုရန်',
      confirmDeposit: 'ငွေသွင်းအကြောင်းကြားရန်',
      loading: 'ဖွင့်နေသည်...',
      generatingButton: 'QR ကုဒ်ကို ဖန်တီးနေပါတယ်...',
      minAmountError: 'ပမာဏသည် {amount} ဘတ်ထက်ပိုရမည်',
      depositError: 'PromptPay ငွေသွင်းမှုတွင် ပြဿနာရှိသည်',
      contactAdmin: 'အက်ဒမင်ကို ဆက်သွယ်ပါ',
      depositSuccess: 'PromptPay ငွေသွင်းမှု အောင်မြင်ပါသည်',
      qrWarning: 'သတိပေးချက်: ဤ QR CODE ကို တစ်ကြိမ်သာ ပေးချေနိုင်ပါသည်။ ထပ်မံမလုပ်ပါနှင့်။ ထပ်မံလုပ်ပါက ငွေဝင်ရောက်မှု နှေးကွေးနိုင်ပါသည်။'
    },
    withdrawModal: {
      modalTitle: 'ငွေထုတ်',
      amountPlaceholder: 'ထုတ်မည့်ပမာဏ',
      minimumNotice: '- အနည်းဆုံးထုတ်ယူမှု 100 ဘတ်',
      confirmButton: 'ငွေထုတ်အတည်ပြုရန်',
      withdrawNotice: 'ငွေထုတ်အကြောင်းကြားချက်',
      turnoverComplete: 'Turnover ပြည့်ပါပြီ! {amount} ဘတ် ထုတ်ယူနိုင်ပါသည်။ အတည်ပြုရန် နှိပ်ပါ။',
      turnoverCompleteSimple: 'Turnover ပြည့်ပါပြီ! ငွေထုတ်ရန် အတည်ပြုခလုတ်ကို နှိပ်ပါ။'
    },
    promotion: {
      title: 'ပရိုမိုးရှင်း',
      receive: 'ပရိုမိုးရှင်းခံယူရန်'
    },
    support: {
      customerService: 'ဖောက်သည်ဝန်ဆောင်မှု',
      service24h: '24 နာရီ ဝန်ဆောင်မှု'
    }
  },
  promotionPage: {
    heroTitle: 'မနားမနေရသော ပရိုမိုးရှင်းများ<br>ဤခေတ်ထဲက အပြင်းထန်ဆုံးဆုလာဘ်များ',
    heroSubtitle: 'ဂိမ်းအများကြီးနဲ့ ထူးခြားသည့်ပရိုမိုးရှင်းများ — အမှန်တကယ် အဆင့်မြင့်ဆုံး။',
    heroCta: 'အကောင့်ဖွင့်ပါ'
  },
  eventPage: {
    heroTitle: 'ပရိုမိုးရှင်းများနှင့် လှုံ့ဆော်ချက်များစွာ<br>ဤမိုမိုအချိန်ထဲက အထူးဆုများ',
    heroSubtitle: 'ဂိမ်းများစွာနဲ့ အထူးခံစားခွင့်များ — အဆင့်မြင့်ဆုံးများသာ ဒီမှာရှိတယ်။',
    heroCta: 'အကောင့်ဖွင့်ပါ',
    alerts: {
      error: 'Error!',
      success: 'Success',
      creditExceeds: 'သင့်တွင် 4 ခရက်ဒစ်ထက်ပို၍ ရှိနေသဖြင့် မကစားနိုင်ပါ!',
      creditExceeds10: 'သင့်တွင် 10 ခရက်ဒစ်ထက်ပို၍ ရှိနေသဖြင့် မကစားနိုင်ပါ!',
      checkinAlready: 'သင်ယနေ့ ဝင်ရောက်ပြီးပါပြီ။ မနက်ဖြန် ပြန်လာပါ!',
      checkinSuccess: 'ဝင်ရောက်မှု အောင်မြင်ပါသည်',
      checkinVerify: 'သင့်ဝင်ရောက်မှုအရည်အချင်းကို အတည်ပြုပါ!',
      enterCode: 'ကုဒ်ထည့်ပါ',
      confirm: 'အတည်ပြုပါ',
      cancel: 'ပယ်ဖျက်ရန်',
      codeInvalid: 'သင့်ကုဒ်ကို စစ်ဆေးပါ!',
      codeAlreadyUsed: 'သင်သည် အခမဲ့ကုဒ်ကို ရယူပြီးပါပြီ!'
    }
  },
  cashbackPage: {
    title: 'Cashback',
    playSummary: 'ကစားမှုပေါင်း',
    deposit: 'ထည့်ငွေ',
    withdraw: 'ထုတ်ငွေ',
    totalIncome: 'ဝင်ငွေစုစုပေါင်း',
    transferButton: 'အဓိကပိုက်ဆံအိတ်သို့ လွှဲမည်'
  },
  partnerPage: {
    title: 'အဖော်စုဆောင်းလင့်ခ်',
    copy: 'ကူးယူရန်',
    copyTitle: 'ကူးယူရန်',
    copySuccess: 'အောင်မြင်စွာကူးယူပြီးပါပြီ',
    shareHint: 'မည်သည့် ချန်နယ်မျိုးမဆို သင့်လင့်ခ်ကိုမျှဝေပြီး ဝင်ငွေ ရယူပါ။',
    earningsTitle: 'မိတ်ဆက်မှ ဝင်ငွေ',
    levelOne: 'တိုက်ရိုက်မိတ်ဆက်',
    levelTwo: 'တဆင့်ချင်း မိတ်ဆက်',
    levelOneIncome: 'တိုက်ရိုက်မိတ်ဆက် ဝင်ငွေ',
    levelTwoIncome: 'တဆင့်ချင်း ဝင်ငွေ',
    totalIncome: 'ဝင်ငွေစုစုပေါင်း',
    summaryNote: '*မနေ့က အချက်အလက်ချုပ်',
    table: {
      code: 'ကုဒ်',
      date: 'နေ့စွဲ',
      deposit: 'ထည့်ငွေ',
      withdraw: 'ထုတ်ငွေ'
    },
    levelOneModalTitle: 'တိုက်ရိုက်မိတ်ဆက်',
    levelTwoModalTitle: 'တဆင့်ချင်း မိတ်ဆက်'
  },
  continuePage: {
    title: 'ဆက်လက်ထည့်သွင်းမှု',
    defaultPromotion: '7 ရက် ဆက်တိုက်ထည့်သွင်း',
    bonus: 'ဘောနပ်စ်',
    rulesHtml: '<p style="text-align:center;padding:30px;font-size:16px;">'
      + '<b>• ဆယ်နေ့တစောင့် 7 ရက် ဆက်တိုက် ထည့်သွင်းရမည်</b><br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 999 ဘတ် — ဘောနပ်စ် 100 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 1,999 ဘတ် — ဘောနပ်စ် 200 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 2,999 ဘတ် — ဘောနပ်စ် 300 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 3,999 ဘတ် — ဘောနပ်စ် 400 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 4,999 ဘတ် — ဘောနပ်စ် 500 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 5,999 ဘတ် — ဘောနပ်စ် 600 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 6,999 ဘတ် — ဘောနပ်စ် 700 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 7,999 ဘတ် — ဘောနပ်စ် 800 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 8,999 ဘတ် — ဘောနပ်စ် 900 ဘတ်<br>'
      + '✨ နေ့စဉ် စုစုပေါင်း 9,999 ဘတ် — ဘောနပ်စ် 1,000 ဘတ်<br>'
      + '• သတ်မှတ်ထားသော ကာစီနို/ဂိမ်းများတွင်သာ အသုံးပြုနိုင်သည်<br>'
      + '• slot ဂိမ်းများတွင် feature (free spin) မစျေးဝယ်ရ<br>'
      + '• ဘောနပ်စ်၏ 3 ဆ အထိသာ ပမာဏထုတ်ယူနိုင်သည်<br>'
      + '• ဘောနပ်စ်သည် ကစားရန်အတွက်သာ ဖြစ်ပြီး ရောင်းသပိတ်ချိန်တွင် ပြန်လှုံ့ဆော်မည်။ '
      + 'ဥပမာ ဘောနပ်စ် 100 ဘတ် သတ်မှတ် ထုတ်ယူနိုင်သည့်ပမာဏ 300 ဘတ် ဖြစ်သည်။ 300 ဘတ် ထက်ကျော်လွန်သော ငွေမှုန့်များကို ပြန်ဖယ်ရှားမည်။<br>'
      + '• နေ့တိုင်း 08:00 - 23:45 (GMT+7) အတွင်း အလိုအလျောက် လက်ခံနိုင်သည်<br>'
      + '• ဘောနပ်စ်လက်ခံမီ စရံငွေ 10 ဘတ် ထက်နည်းရမည်'
      + '</p>'
  },
  huayPage: {
    title: 'ထည့်သွင်းမှုအခြေအနေများ',
    depositCondition: '**300 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး ထီပွဲဝင်ခွင့် ချက်ချင်းရရှိမည် (ထီထွက်ရက်များတွင်သာ)**',
    rewardText: 'မှန်ကန်စွာခန့်မှန်းပြီး 500 ခရက်ဒစ်နှင့် 2x turnover ရရှိမည်',
    conditionsTitle: '📣 ပွဲဝင်ခွင့်အခြေအနေများ 📣',
    condition1: '1. အနည်းဆုံး 300 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းရမည်',
    condition2: '2. 1 slip သည် 1 ကြိုတင်ခန့်မှန်းခွင့် ရရှိနိုင်သည်',
    condition3: '3. 2 လုံး ထိပ်ဆုကို အကြိမ်အရေအတွက် မရှိဘဲ ခန့်မှန်းနိုင်သည်',
    condition4: '4. ခန့်မှန်းမှုသည် ထီထွက်ရက် 15:00 တွင် ပိတ်သည်',
    condition5: '5. ထီထွက်ရက် 16:00 မတိုင်မီ 1 turnover ကစားထားရမည်',
    condition6: '6. အခမဲ့ခရက်ဒစ်ဆုများကို ထီထွက်ရက် 19:00 အတွင်း ပေါင်းထည့်မည်',
    confirmButton: 'ထီလောင်းကို အတည်ပြုရန်',
    loading: 'loading...',
    loadingText: 'loading',
    successMessage: 'ထီလောင်းမှု အောင်မြင်ပါသည် 😘',
    checkRightsAlert: 'သင့်လောင်းကစားခွင့်များကို စစ်ဆေးပါ',
    errorMessage: 'ဒေတာသိမ်းဆည်းရာတွင် အမှားတစ်ခုဖြစ်ပွားခဲ့သည်။ ကျေးဇူးပြု၍ ထပ်စမ်းကြည့်ပါ',
    okButton: 'OK'
  },
  rouletPage: {
    title: 'ရူးလက် အခမဲ့ခရက်ဒစ်များ',
    depositCondition: '**1000 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး လှည့်ခွင့် ချက်ချင်းရရှိမည် (တနင်္လာနှင့် သောကြာရက်များသာ)**',
    spinButton: 'ယခုလှည့်ရန်',
    spinRights: 'လှည့်ခွင့်',
    rounds: 'ကြိမ်',
    depositPrompt: '1000 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး ချက်ချင်းလှည့်ခွင့်ရရှိမည်',
    creditExceeds: 'သင့်တွင် 4 ခရက်ဒစ်ထက်ပို ရှိနေသဖြင့် မကစားနိုင်ပါ!',
    noPermissionTitle: 'ရူးလက်လှည့်ခွင့် မရှိပါ',
    noPermission: '1000 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး ချက်ချင်းလှည့်ခွင့်ရရှိမည် (တနင်္လာနှင့် သောကြာရက်များသာ)',
    loseMessage: 'တောင်းပန်ပါသည်၊ ဤတစ်ကြိမ်တွင် ဆုမရရှိပါ',
    winMessage: 'ဂုဏ်ယူပါတယ်! သင်အနိုင်ရခဲ့သည်',
    credit: 'ခရက်ဒစ်',
    coin: 'ဒင်္ဂါးများ',
    okButton: 'OK'
  },
  spinPage: {
    title: 'ဘီးလှည့် အခမဲ့ခရက်ဒစ်များ',
    depositCondition: '**500 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး လှည့်ခွင့် ချက်ချင်းရရှိမည် (တနင်္လာနှင့် သောကြာရက်များသာ)**',
    spinRights: 'လှည့်ခွင့်',
    rounds: 'အကြိမ်',
    depositPrompt: '500 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး ချက်ချင်းလှည့်ခွင့်ရရှိမည်',
    creditExceeds: 'သင့်တွင် 4 ခရက်ဒစ်ထက်ပို ရှိနေသဖြင့် မကစားနိုင်ပါ!',
    noPermissionTitle: 'ဘီးလှည့်ခွင့် မရှိပါ',
    noPermission: '500 ဘတ် သို့မဟုတ် ထက်ပို ထည့်သွင်းပြီး ချက်ချင်းလှည့်ခွင့်ရရှိမည် (တနင်္လာနှင့် သောကြာရက်များသာ)',
    winMessage: 'သင်ရရှိခဲ့သည်',
    credit: 'ခရက်ဒစ်',
    points: 'Points',
    formula: 'တွက်ချက်မှုပုံသေနည်း',
    hours: 'နာရီ',
    okButton: 'OK'
  },
  common: {
    conditionTitle: 'အခြေအနေ',
    conditionMessage: 'ဤအကျိုးခံစားခွင့်ကို ရယူရန် အကြွေစျေး 5 ဘတ် ထက်နည်းရပါမည်။',
    confirm: 'အတည်ပြုပါ',
    back: 'နောက်သို့',
    haveProblem: 'ပြဿနာရှိပါသလား',
    contactSupport: 'ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ'
  },
  account: {
    info: 'အကောင့်အချက်အလက်',
    joinedPromotion: 'ပူးပေါင်းထားသော ပရိုမိုးရှင်းများ',
    history: 'ငွေကြေးသမိုင်း',
    logout: 'ထွက်ရန်',
    confirmLogout: 'ထွက်လိုပါသလား?',
    changePassword: 'လျှို့ဝှက်နံပါတ်ပြောင်းရန်',
    currentPassword: 'လက်ရှိလျှို့ဝှက်နံပါတ်',
    newPassword: 'လျှို့ဝှက်နံပါတ်အသစ်',
    confirmNewPassword: 'လျှို့ဝှက်နံပါတ်အသစ်ထပ်ထည့်ပါ'
  },
  home: {
    category: {
      jackpot: 'Jackpot ဂိမ်းများ',
      popular: 'လူကြိုက်များသောဂိမ်းများ',
      new: 'ဂိမ်းအသစ်များ',
      slot: 'Slot ဂိမ်းများ',
      liveCasino: 'တိုက်ရိုက်ကာစီနို',
      review: 'ဖောက်သည်ငွေထုတ်သုံးသပ်ချက်များ'
    },
    game: {
      play: 'ကစားရန်',
      lobby: 'Lobby ဝင်ရန်',
      allGames: 'ဂိမ်းအားလုံး',
      gamesCount: 'ဂိမ်းများ'
    },
    badge: {
      hot: 'Hot',
      new: 'New'
    },
    popular: {
      title: 'မကြာခဏအနိုင်ရသော လူကြိုက်များ Online Slots',
      highPayout: 'မြင့်မားသောအနိုင်နှုန်း',
      easyBonus: 'လွယ်ကူသော ဘောနပ်စ်',
      funGraphics: 'ပျော်စရာ ပုံနှင့်အသံ',
      playAnytime: 'အချိန်မရွေး ကစားနိုင်သည် 24/7'
    },
    slot: {
      title: 'ဂိမ်းထောက်ပံ့သူအားလုံးကို ကစားနိုင် - လွှဲမရန်မလို',
      allProviders: 'ဂိမ်းထောက်ပံ့သူအားလုံး ရရှိနိုင်',
      directWeb: 'တိုက်ရိုက်ဝဘ်ဝန်ဆောင်မှု',
      autoSystem: 'အော်တို စနစ်',
      safe: '100% လုံခြုံသည်'
    },
    casino: {
      title: 'ကမ္ဘာ့အဆင့် တိုက်ရိုက်ကာစီနို!',
      baccarat: 'ဘက်ကာရာ',
      sicbo: 'Sic Bo',
      dragonTiger: 'နဂါးကျား',
      poker: 'ပေါ်ကာ',
      roulette: 'ရူးလက်',
      blackjack: 'Blackjack',
      hilo: 'Hi-Lo',
      bannerTitle: 'Premium တိုက်ရိုက်ကာစီနို',
      bannerSubtitle: 'ဘက်ကာရာ | Sic Bo | နဂါးကျား | ရူးလက်'
    },
    feature: {
      smartWallet: {
        title: 'Smart Wallet',
        detail: 'ဂိမ်းအားလုံးကစားနိုင်<br>လွှဲမရန်မလို'
      },
      rank: {
        title: 'ထိုင်းတွင် No.1',
        detail: 'နည်းပညာနှင့် ဂိမ်းများ<br>ကမ္ဘာတစ်ဝှမ်းမှ'
      },
      transaction: {
        title: 'မြန်သော ငွေသွင်း - ငွေထုတ်',
        detail: 'အလွန်မြန်သော ငွေကြေးလွှဲပြောင်း<br>Bot AI စနစ်ဖြင့်'
      },
      everywhere: {
        title: 'နေရာတိုင်းမှာ ကစားနိုင်',
        detail: 'အသုံးပြုရလွယ်သော စနစ်<br>စက်ပစ္စည်းအားလုံး ထောက်ပံ့'
      },
      support: {
        title: 'ဂရုစိုက်ဝန်ဆောင်မှု',
        detail: 'ဖောက်သည်ဝန်ဆောင်မှု<br>24/7 နေ့စဉ်'
      },
      promotion: {
        title: 'သင့်အတွက် အကောင်းဆုံး ပရိုမိုးရှင်းများ',
        detail: 'ထိုင်းတွင် အမျိုးမျိုးသော<br>လုပ်ဆောင်ချက်များနှင့် ပရိုမိုးရှင်းများ'
      }
    },
    announcement: {
      title: '📢 အရေးကြီးသော ကြေညာချက်',
      noShowAgain: 'ဤမက်ဆေ့ချ်ကို နောက်တစ်ကြိမ်မပြပါနှင့်',
      acknowledge: 'အသိအမှတ်ပြု'
    }
  },
  rewardsPage: {
    heroTitle: 'ဆုလာဘ်များ ပေါများစွာ <br>  အချိန်မရွေး လဲလှယ်နိုင်',
    heroSubtitle: 'အကြွေစေ့များစုဆောင်းပြီး ရနိုင်သော ဆုလာဘ်အားလုံးကို အချိန်မရွေး လဲလှယ်နိုင်',
    redeemButton: 'ယခုလဲလှယ်',
    confirmMessage: '{name} ကို လဲလှယ်လိုပါသလား?',
    confirmYes: 'အတည်ပြု',
    confirmNo: 'ပယ်ဖျက်',
    creditRedeemTitle: 'ခရက်ဒစ်လဲလှယ်',
    creditRedeemError: 'သင့်လက်ကျန်ငွေသည် 5 ဘတ်ထက်များသောကြောင့် ခရက်ဒစ်လဲလှယ်၍မရပါ'
  },
  historyPage: {
    title: 'ငွေကြေးမှတ်တမ်း',
    dateTime: 'ရက်စွဲ/အချိန်',
    type: 'အမျိုးအစား',
    amount: 'ပမာဏ',
    status: 'အခြေအနေ',
    types: {
      wheel: 'ဘီးလှည့်',
      treasureBox: 'ရတနာသေတ္တာ',
      roulette: 'ရူးလက်',
      checkin: 'ချက်အင်',
      code: 'ကုဒ်',
      scratch: 'ခြစ်ကတ်',
      giftBox: 'လက်ဆောင်သေတ္တာ',
      continuousDeposit: 'ဆက်တိုက်ငွေသွင်း',
      partner: 'မိတ်ဖက်',
      cashback: 'ငွေပြန်အမ်း',
      deposit: 'ငွေသွင်း',
      withdraw: 'ငွေထုတ်'
    },
    statuses: {
      completed: 'ပြီးစီး',
      cancelled: 'ပယ်ဖျက်ထား',
      pending: 'စောင့်ဆိုင်း'
    }
  },
  footer: {
    contact: {
      customerService: 'ဖောက်သည်ဝန်ဆောင်မှု',
      service24h: '24 နာရီ ဝန်ဆောင်မှု'
    },
    actions: {
      home: 'ပင်မစာမျက်နှာ',
      deposit: 'ငွေသွင်း',
      withdraw: 'ငွေထုတ်',
      contactUs: 'ကျွန်ုပ်တို့ကို ဆက်သွယ်ပါ'
    },
    description: '2024 ခုနှစ်တွင် အကြီးမားဆုံး အွန်လိုင်းကာစီနို ဝန်ဆောင်မှုပေးသူဖြစ်ပြီး၊ ကျွမ်းကျင်သူအဖွဲ့များမှ အကောင်းဆုံး စနစ်ဖွံ့ဖြိုးတိုးတက်မှုနှင့် တိုးတက်မှုများဖြင့် လောင်းကစားသမားများကို ၎င်းတို့၏ လောင်းကစားခရီးတလျှောက် တစ်နေ့လုံး ကူညီပေးသည့် အဖွဲ့များ ရှိပါသည်။',
    banks: {
      title: 'ကျွန်ုပ်တို့ ထောက်ပံ့သော ဘဏ်များ'
    },
    partners: {
      title: 'ကျွန်ုပ်တို့၏ လုပ်ဖော်ကိုင်ဖက်များ'
    },
    autoSystem: 'မြန်ဆန်ပြီး ခေတ်မီသော AUTO ငွေသွင်း-ထုတ် စနစ်ဖြင့်',
    copyright: 'Copyright ©2024, All Rights Reserved. TOKYO789'
  }
}
